import { forwardRef as reactForwardRef, type ReactNode, type Ref, type RefAttributes } from "react";

// Declare a type that works with generic components
type FixedForwardRef = <T, P = unknown>(
  render: (props: P, ref: Ref<T>) => ReactNode,
) => (props: P & RefAttributes<T>) => ReactNode;

export const forwardRef = reactForwardRef as FixedForwardRef;
